import { Deserializable } from '../../deserializable';

export interface ILoginRequestDTO {
  email: string;
  password: string;
  recaptchaResponse?: string;
}

/**
 * Login Request DTO used to interact with backend
 */
export class LoginRequestDTO
  extends Deserializable
  implements ILoginRequestDTO { // eslint-disable-line
  /**
   * @constructor
   */
  constructor(
    public email: string,
    public password: string,
    public recaptchaResponse?: string
  ) {
    super();
  }
}
